(function (host) {
  'use strict';
  function estimate(source, line) {
    if (source && (source.kind === 'digital' || (source.digitalVariantIds || []).includes(String(line.id)))) return {kind:'digital'};
    if (source && !source.physicalVariantIds.includes(String(line.id))) return {kind:'confirm'};
    if (!source || line.available === false || line.mode === 'quote' || line.mode === 'catalog_only') return {kind:'confirm'};
    return {kind:source.kind,min:source.min,max:source.max};
  }
  function combine(rows) {
    if (!rows.length) return {kind:'confirm',causes:[]};
    var physical = rows.filter(function (row) {return row.estimate.kind !== 'digital';});
    if (!physical.length) return {kind:'digital'};
    var unknown = physical.filter(function (row) {return row.estimate.kind !== 'range';});
    if (unknown.length) return {kind:'confirm',causes:unknown};
    var min = Math.max.apply(null,physical.map(function (row) {return row.estimate.min;}));
    var max = Math.max.apply(null,physical.map(function (row) {return row.estimate.max;}));
    return {kind:'range',min:min,max:max,causes:physical.filter(function (row) {return row.estimate.max === max;})};
  }
  function render(root, main, selected, cards, assessment) {
    var panel = root.querySelector('.hw-dispatch');
    if (!panel) return;
    panel.hidden = assessment.catalog;
    var labels = JSON.parse(root.querySelector('[data-hw-dispatch-labels]').textContent);
    var sources = Array.from(root.querySelectorAll('[data-hw-dispatch-data]')).map(function (el) {return JSON.parse(el.textContent);});
    function sourceFor(id) {return sources.find(function (source) {return source.productId === String(id);});}
    function range(value) {return value.min+'–'+value.max+' '+labels.days;}
    function label(value, short) {return value.kind === 'range' ? (short ? '' : labels.dispatch+': ')+range(value) : labels[value.kind] || labels.confirm;}
    cards.forEach(function (card) {
      var el = card.el.querySelector('[data-hw-item-dispatch]');
      if (el) el.textContent = label(estimate(sourceFor(card.data.productId), card.selected), false);
    });
    var rows = selected.map(function (line) {
      var source = sourceFor(line.productId);
      return {title:String(line.productId) === String(main.productId) ? labels.selected_kit : line.title || (source ? source.title : ''),quantity:line.quantity,estimate:estimate(source,line)};
    });
    var result = combine(rows);
    if (assessment.quoteOnly && result.kind === 'range') result = {kind:'confirm',causes:[]};
    root.querySelector('[data-hw-dispatch-overall]').textContent = result.kind === 'range' ? labels.complete+': '+range(result) : result.kind === 'digital' ? labels.none : labels.confirm;
    var reason = root.querySelector('[data-hw-dispatch-reason]');
    var causes = result.causes || [];
    reason.hidden = !causes.length || result.kind === 'range' && causes.length === rows.length;
    reason.textContent = (result.kind === 'range' ? labels.longest : labels.confirm_items)+' '+causes.map(function (row) {return row.title;}).join('; ');
    var list = root.querySelector('[data-hw-dispatch-items]');
    list.replaceChildren();
    rows.forEach(function (row) {
      var entry = document.createElement('div'),name = document.createElement('dt'),time = document.createElement('dd');
      name.textContent = row.title+' × '+row.quantity;
      time.textContent = label(row.estimate,true);
      entry.append(name,time);list.appendChild(entry);
    });
  }
  var api = {estimate:estimate,combine:combine,render:render};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else host.KnoxKitDispatch = api;
})(typeof window !== 'undefined' ? window : this);
